export default __webpack_public_path__ + "static/media/fast(2).99bd6fec.svg";